import { ProFormRadio } from '@ant-design/pro-form';
import React, { FC } from 'react';
import { RadioGroupFormTypeOption } from '@/presentation/components/form/index';

export const RadioGroupForm: FC<{ entry: RadioGroupFormTypeOption, hidden?: boolean }> = (props) => {
  const { name, label, options, initialValue, transform, convertValue } = props.entry;

  return <ProFormRadio.Group
    transform={transform}
    convertValue={convertValue}
    options={options}
    name={name}
    label={label}
    initialValue={initialValue}
    hidden={props.hidden}
  />;
};
